export enum Roles {
  Client = "CLIENT",
  Doctor = "DOCTOR",
  Admin = "ADMIN"
}
